import { AbstractControl, ValidatorFn } from '@angular/forms';
import { parseISO } from 'date-fns';

export class FromToDateValidators {
  static fromToDate(
    fromDateField: string,
    toDateField: string,
    errorName = 'fromToDate',
  ): ValidatorFn {
    return (formGroup: AbstractControl): { [key: string]: boolean } | null => {
      const fromDate = formGroup.get(fromDateField)?.value;
      const toDate = formGroup.get(toDateField)?.value;

      if (!fromDate) {
        return { ['fromDateEmpty']: true };
      } else if (!fromDate && !toDate) {
        return { ['fromToDateEmpty']: true };
      } else if (toDate && fromDate > toDate) {
        return { [errorName]: true };
      }
      return null;
    };
  }

  static dateBefore(
    fromDateField: string,
    toDateField: string,
    errorName = 'dateBefore',
  ): ValidatorFn {
    return (formGroup: AbstractControl): { [key: string]: boolean } | null => {
      const fromDate = formGroup.get(fromDateField)?.value;
      const toDate = formGroup.get(toDateField)?.value;

      if (toDate && fromDate > toDate) {
        return { [errorName]: true };
      }

      return null;
    };
  }

  static maxPeriodLength(
    maxDays: number,
    fromDateField: string,
    toDateField: string,
    errorName = 'maxPeriodLength',
  ): ValidatorFn {
    return (formGroup: AbstractControl): { [key: string]: boolean } | null => {
      const fromDate = formGroup.get(fromDateField)?.value;
      const toDate = formGroup.get(toDateField)?.value;

      // Als een van beide datums ontbreekt, geen validatie uitvoeren
      if (!fromDate || !toDate) {
        return null;
      }

      // Converteer strings naar Date objecten
      const startDate = new Date(fromDate);
      const endDate = new Date(toDate);

      // Bereken het verschil in dagen
      const timeDifference = endDate.getTime() - startDate.getTime();
      const daysDifference = Math.ceil(timeDifference / (1000 * 3600 * 24));

      // Controleer of de periode langer is dan het maximum aantal dagen
      if (daysDifference > maxDays) {
        return { [errorName]: true };
      }

      return null;
    };
  }

  static dateTimeBefore(
    fromDateField: string,
    fromTimeField: string,
    toDateField: string,
    toTimeField: string,
    errorName = 'dateTimeBefore',
  ): ValidatorFn {
    return (formGroup: AbstractControl): { [key: string]: boolean } | null => {
      const fromDate = formGroup.get(fromDateField)?.value;
      const fromTime = formGroup.get(fromTimeField)?.value;
      const toDate = formGroup.get(toDateField)?.value;
      const toTime = formGroup.get(toTimeField)?.value;

      const from = fromDate && fromTime ? parseISO(`${fromDate} ${fromTime}`).toISOString() : null;
      const to = toDate && toTime ? parseISO(`${toDate} ${toTime}`).toISOString() : null;

      if (from && to && from > to) {
        return { [errorName]: true };
      }

      return null;
    };
  }
}
